export default __webpack_public_path__ + "static/media/money-back.c0d52299.png";